import React from "react";
import Map from "./Map/Map";

const APanIndiaNetwork = () => {
  return (
    <>
      <section
        className="py-3 container"
        // style={{ backgroundImage: "url(./img/shapes/waves-white.svg)" }}
      >
        {/* <span className="mask opacity-8" /> */}
        <div className="container py-5">
          <div className="row align-items-center">
            <div
              className="col-md-6 mb-md-0 mb-4 px-2"
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
            >
              <h3 className="textt-gradient mb-0">Nationwide Supply Network</h3>
              <p
                className="mb-md-5 mb-4 mt-3 "
                style={{
                  fontSize: "1.35rem",
                }}
              >
                Our strategic presence enables our team for catering projects
                throughout the nation, from Kashmir to Kanyakumari and from
                Dwarka to Kohima.
              </p>
            </div>
            <div
              className="col-md-6 "
              data-aos="fade-left"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
            >
              <Map />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default APanIndiaNetwork;
